import React from 'react';
import type { ShortcutScope } from './keymap';
import { useShortcutContext } from './ShortcutProvider';

/**
 * For a feature's own `keydown` listener (e.g. `usePinPhysicalKeys`): returns
 * a stable function that reads, at call time, whether `scope` is the live top
 * of the shortcut stack. A listener that checks it on every key suspends the
 * same way a `useShortcut` binding does when a dialog — the cheat sheet
 * included — pushes its own scope on top.
 */
export const useIsShortcutScopeActive = (
    scope: ShortcutScope,
): (() => boolean) => {
    const { getActiveScope } = useShortcutContext();
    return React.useCallback(
        () => getActiveScope() === scope,
        [getActiveScope, scope],
    );
};
